import questionSingle from './src'
questionSingle.install = Vue => {
    Vue.component(questionSingle.name, questionSingle)
}
export default questionSingle



// WEBPACK FOOTER //
// ./packages/question-single/index.js